<template>
  <modal
    :show.sync="isActiveLocal"
    size="xl"
    centered
    modal-content-classes="cust-modal-ht-wo"
    hide-header
    class="overflow-y-hidden"
  >
    <div class="text-black md:p-8 lg:p-8 p-0">
      <div class="">
        <div class="flex justify-between pb-4">
          <div class="flex">
            <img
              :src="
                selectedTesimonial.image
                  ? `${$imageURL}/${selectedTesimonial.image}`
                  : require(`@/assets/images/AuthorImage.jpg`)
              "
              alt="user"
              class="md:h-32 lg:h-32 h-16 md:w-32 lg:w-32 w-16 md:mx-4 lg:mx-4 rounded-full"
            />
            <div class="mx-2 my-auto">
              <p class="font-medium text-lg md:text-2xl text-black">
                {{ selectedTesimonial.name }}
              </p>
              <p class="clr777 font-normal lg:text-lg text-sm">
                {{
                  selectedTesimonial.designation
                    ? selectedTesimonial.designation
                    : ""
                }}
              </p>
            </div>
          </div>
          <img
            src="../../../assets/images/cross.png"
            class="md:h-8 lg:h-8 h-6 md:w-8 lg:w-8 w-6 cursor-pointer"
            alt="cross"
            @click="isActiveLocal = false"
          />
        </div>
        <div class="pt-4">
          <p class="" v-html="selectedTesimonial.description"></p>
        </div>
      </div>
    </div>
    <!-- <template slot="footer" class="hidden"> <div></div> </template> -->
  </modal>
</template>
<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedTesimonial: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
